import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
    constructor(private _router: Router) {}

    canActivate(): boolean {
        const accessToken = localStorage.getItem('a_ad_token');
        const refreshToken = localStorage.getItem('r_ad_token');
        if (accessToken && refreshToken) {
            console.log('login guard calls')
            this._router.navigate(['/layouts']);
            return false;
        }
        return true;
    }
}